import { useEffect, useState } from 'react'
import { IconButton } from 'shared/ui/IconButton'
import { getAriaLabel } from 'shared/lib'
import { paginationCountList as paginationCountListConst } from 'shared/ui/TableNew/constants/constants'
import { PaginationSelect } from './PaginationSelect'
import styles from './styles.module.scss'

type IPaginationProps = {
  total: number
  onChange: (page: number, limit: number) => void
  initPage?: number
  limit?: number | null
  startSize?: number | null
}

export const Pagination = ({ total, onChange, initPage, limit, startSize }: IPaginationProps) => {
  const paginationCountList = startSize
    ? paginationCountListConst.filter((count) => count >= startSize)
    : paginationCountListConst

  const [pageSize, setPageSize] = useState<number>(limit || paginationCountList[0])
  const [page, setPage] = useState<number>(initPage || 1)
  const pageCount = Math.ceil(total / pageSize)
  const from = `${(page - 1) * pageSize + 1} `
  const maxCount = page * pageSize
  const to = maxCount > total ? total : maxCount
  const fromToValue = `${from} - ${to}`
  const singlePageTable = pageCount === 1

  const changePageSize = (newSize: number) => {
    if (newSize === pageSize) return

    setPageSize(newSize)
    setPage(1)
    onChange(1, newSize)
  }

  const changePage = (newPage: number) => {
    onChange(newPage, pageSize)
    setPage(newPage)
  }

  useEffect(() => {
    setPage(initPage || 1)
  }, [initPage])

  useEffect(() => {
    setPageSize(limit || paginationCountList[0])
  }, [limit])

  return (
    <div className={styles.container} aria-label={getAriaLabel('Pagination')}>
      <IconButton
        icon={'chevronLeft'}
        size={'small'}
        variant={'icon'}
        color={'secondary'}
        onClick={() => {
          changePage(page - 1)
        }}
        disabled={page === 1}
        ariaLabel='Pagination_previous'
      />

      <IconButton
        icon={'chevronRight'}
        size={'small'}
        variant={'icon'}
        color={'secondary'}
        onClick={() => {
          changePage(page + 1)
        }}
        disabled={singlePageTable || page >= pageCount}
        ariaLabel='Pagination_next'
      />

      <PaginationSelect
        fromToValue={fromToValue}
        pageSize={pageSize}
        setPageSize={changePageSize}
        paginationCountList={paginationCountList}
      />

      <span className={styles.allRowsCount}>of {total}</span>
    </div>
  )
}
